/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import publicPath from '../../utils/publicPath';
import AccredationLevel from '../AccredationLevel';
import useClubDetailsStyle from '../ClubDetails/styles';
import DisplayInformation from '../DisplayInformation';
import Text from '../Text';
import useStyles from '../VenueDetails/styles';
import useStylesClub from './styles';

export const aboutTeamRef = React.createRef();

const TeamInfo = ({ teamDetails, accreditation, onClick }) => {
  const { teaminfo, facilities, county, title } = teamDetails;
  const styles = useStyles();
  const stylesClub = useStylesClub();
  const clubDetailsStyle = useClubDetailsStyle();
  const hasMoreInfo =
    county || (accreditation && accreditation.isAccreditation);
  const { values: footballTypesValues } = teaminfo;
  const { values: facilitiesVals } = facilities;
  const facilitiesValsArr = Array.isArray(facilitiesVals) ? facilitiesVals : [];
  const facilitiesValues = facilitiesValsArr[2] ? [facilitiesValsArr[2], ...facilitiesValsArr.slice(0, 2)] : [];
  const filteredFootballTypesValues = footballTypesValues.filter(
    value => value.title !== 'Teams football types'
  );
  const competitionsValues = footballTypesValues.filter(
    value => value.title === 'Teams football types'
  );
  return (
    <Fragment>
      <div css={clubDetailsStyle.middlePart} ref={aboutTeamRef}>
        <div css={styles.leftContent}>
          <div css={clubDetailsStyle.top}>
            <Text as="h2" size="5" css={stylesClub.title}>
              About this team
            </Text>
            {hasMoreInfo && (
              <>
                {accreditation && accreditation.isAccreditation && title && (
                  <div css={clubDetailsStyle.imageWrap}>
                    <img
                      src={publicPath(
                        `/images/common/ef-accredited-club-rating.svg`
                      )}
                      alt={`This club has an FA Accreditation`}
                      width="100%"
                    />
                    {accreditation && <AccredationLevel {...accreditation} />}
                  </div>
                )}
              </>
            )}
          </div>
          {county && (
            <DisplayInformation
              singleGroupValue={true}
              singleGroupLabelText="County FA"
              singleGroupValueText={county}
            />
          )}
          {competitionsValues && (
            <DisplayInformation
              staticGroupLabel={true}
              staticGroupLabelText="Competitions"
              values={competitionsValues}
            />
          )}

          {filteredFootballTypesValues && (
            <DisplayInformation
              staticGroupLabel={true}
              staticGroupLabelText="Team Information"
              values={filteredFootballTypesValues}
            />
          )}

          {facilitiesValues && (
            <DisplayInformation
              dynamicGroupLabel={true}
              values={facilitiesValues}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

TeamInfo.propTypes = {
  teamDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  accreditation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onClick: PropTypes.func, 
};

export default TeamInfo;
